module.exports = __webpack_public_path__ + "static/media/notification.e48b073d.svg";